import { Env } from "./ConfigInterface";
import featureFlagConfig, { FeatureFlagType } from "./FeatureFlagConfigs";
import myApprovalConfigs, { ApprovalConfig } from "./MyApprovalConfig";
import otherConfigs, { OtherConfig } from "./OtherConfigs";
import proxyConfig, { ProxyConfig } from "./ProxyConfig";

export type UrlConfig = {
    nodeService: string
    aiServer: string
    gatewayURL: string
    fromJiraAuth: string
    apikeyUrl: string
    gingcoURL: string
    elasticSearchBaseUrl: string
    elasticSearchProxyUrl: string
    elasticSearchDashboardUrl: string
    serviceUrl: string
    gingcoRedirectURL: string
    jiraURL: string
    jiraClientId: string
    snowUrl: string
    recentChatEnvPrefix: string
    serviceNowRoutesIndex: string
};

const useLocalNode = false;
const useLocalAiServer = false;

const envConfig: Record<Env, UrlConfig> = {
    local: {
        nodeService: useLocalNode ? "http://localhost:3000" : "https://dev-myhelp.eon.com",
        aiServer: useLocalAiServer ? "http://localhost:8000" : "https://ai.dev-myhelp.eon.com",
        gatewayURL: "https://dev-myhelp.eon.com",
        apikeyUrl: "https://dev-myhelp.eon.com/apikey",
        fromJiraAuth: "http://localhost:8080/fromJiraAuth",
        // apikeyUrl: "http://localhost:1236/apikey",
        gingcoURL: "https://dev-myhelp.eon.com",
        elasticSearchBaseUrl: "https://f0571c62200b4d249a4c6750ab7f4716.westeurope.azure.elastic-cloud.com:9243",
        elasticSearchProxyUrl: "https://dev-myhelp.eon.com/elastic",
        elasticSearchDashboardUrl: "https://me8eon-elasticsearchpoc.kb.westeurope.azure.elastic-cloud.com:9243/",
        jiraURL: "https://jira.pre-prod.eon.com",
        jiraClientId: "40873da2f2b33118d3f5f1857991bb74",
        serviceUrl: "https://api-nonprod.eon.com/edt/itsm/dev",
        gingcoRedirectURL: "https://eon-test.gingco-estate.com",
        snowUrl: "https://siamdev.service-now.com/api",
        recentChatEnvPrefix: "local",
        //serviceNowRoutesIndex: "servicenow_routes_inst_semantic_index_test",
        serviceNowRoutesIndex: "servicenow_routes_semantic_index_nonprod",
    },
    dev: {
        nodeService: "https://dev-myhelp.eon.com",
        aiServer: "https://ai.dev-myhelp.eon.com",
        gatewayURL: "https://dev-myhelp.eon.com",
        apikeyUrl: "https://dev-myhelp.eon.com/apikey",
        fromJiraAuth: "https://dev-myhelp.eon.com/fromJiraAuth",
        gingcoURL: "",
        elasticSearchBaseUrl: "https://f0571c62200b4d249a4c6750ab7f4716.westeurope.azure.elastic-cloud.com:9243",
        elasticSearchProxyUrl: "https://dev-myhelp.eon.com/elastic",
        elasticSearchDashboardUrl: "https://me8eon-elasticsearchpoc.kb.westeurope.azure.elastic-cloud.com:9243/",
        jiraURL: "https://jira.pre-prod.eon.com",
        jiraClientId: "1aca69ae8a371428a5d525810457579d",
        serviceUrl: "https://api-nonprod.eon.com/edt/itsm/dev",
        gingcoRedirectURL: "https://eon-test.gingco-estate.com",
        snowUrl: "https://siamdev.service-now.com/api",
        recentChatEnvPrefix: "dev",
        //serviceNowRoutesIndex: "servicenow_routes_inst_semantic_index_test",
        serviceNowRoutesIndex: "servicenow_routes_semantic_index_nonprod",
    },
    qa: {
        nodeService: "https://qa-myhelp.eon.com",
        aiServer: "https://ai.qa-myhelp.eon.com",
        gatewayURL: "https://qa-myhelp.eon.com",
        apikeyUrl: "https://qa-myhelp.eon.com/apikey",
        fromJiraAuth: "https://qa-myhelp.eon.com/fromJiraAuth",
        gingcoURL: "",
        elasticSearchBaseUrl: "https://f0571c62200b4d249a4c6750ab7f4716.westeurope.azure.elastic-cloud.com:9243",
        elasticSearchProxyUrl: "https://qa-myhelp.eon.com/elastic",
        elasticSearchDashboardUrl: "https://me8eon-elasticsearchpoc.kb.westeurope.azure.elastic-cloud.com:9243/",
        jiraURL: "https://jira.pre-prod.eon.com",
        jiraClientId: "6c2bae8c7ffbab498bec72ef689fe32a",
        serviceUrl: "https://api-nonprod.eon.com/edt/itsm/preprod",
        gingcoRedirectURL: "https://eon-test.gingco-estate.com",
        snowUrl: "https://siamdev.service-now.com/api",
        recentChatEnvPrefix: "qa",
        //serviceNowRoutesIndex: "servicenow_routes_inst_semantic_index_test",
        serviceNowRoutesIndex: "servicenow_routes_semantic_index_nonprod",
    },
    pp: {
        nodeService: "https://pp-myhelp.eon.com",
        aiServer: "https://ai.pp-myhelp.eon.com",
        gatewayURL: "https://pp-myhelp.eon.com",
        apikeyUrl: "https://pp-myhelp.eon.com/apikey",
        fromJiraAuth: "https://pp-myhelp.eon.com/fromJiraAuth",
        gingcoURL: "",
        elasticSearchBaseUrl: "https://f0571c62200b4d249a4c6750ab7f4716.westeurope.azure.elastic-cloud.com:9243",
        elasticSearchProxyUrl: "https://pp-myhelp.eon.com/elastic",
        elasticSearchDashboardUrl: "https://me8eon-elasticsearchpoc.kb.westeurope.azure.elastic-cloud.com:9243/",
        jiraURL: "https://jira.pre-prod.eon.com",
        jiraClientId: "c52586ca2e1c83567ed62401e1904919",
        serviceUrl: "https://api-nonprod.eon.com/edt/itsm/preprod",
        gingcoRedirectURL: "https://eon.gingco-estate.com",
        snowUrl: "https://siamdev.service-now.com/api",
        recentChatEnvPrefix: "pp",
        serviceNowRoutesIndex: "servicenow_routes_inst_semantic_index_prod",
    },
    prod: {
        nodeService: "https://myhelp.eon.com",
        aiServer: "https://ai.myhelp.eon.com",
        gatewayURL: "https://myhelp.eon.com",
        apikeyUrl: "https://myhelp.eon.com/apikey",
        fromJiraAuth: "https://myhelp.eon.com/fromJiraAuth",
        gingcoURL: "",
        elasticSearchBaseUrl: "https://f0571c62200b4d249a4c6750ab7f4716.westeurope.azure.elastic-cloud.com:9243",
        elasticSearchProxyUrl: "https://myhelp.eon.com/elastic",
        elasticSearchDashboardUrl: "https://me8eon-elasticsearchpoc.kb.westeurope.azure.elastic-cloud.com:9243/",
        jiraURL: "https://jira.eon.com",
        jiraClientId: "2c25ea9b115d829e5250ee36d4929f9e",
        serviceUrl: "https://api.eon.com/edt/itsm",
        gingcoRedirectURL: "https://eon.gingco-estate.com",
        snowUrl: "https://siamdev.service-now.com/api",
        recentChatEnvPrefix: "prod",
        serviceNowRoutesIndex: "servicenow_routes_inst_semantic_index_prod",

    },
};


let env: Env;
switch (process.env.REACT_APP_ENV) {
case "dev":
    env = "dev";
    break;
case "qa":
    env = "qa";
    break;
case "pp":
    env = "pp";
    break;
case "prod":
    env = "prod";
    break;
default:
    env = "local";
    break;
}

export function elasticSearchWebUrl() {
    return "https://me8eon-elasticsearch-test.kb.westeurope.azure.elastic-cloud.com:9243/";
}

export type AllConfig = UrlConfig & OtherConfig & ApprovalConfig & FeatureFlagType & ProxyConfig;
export const EnvironmentConfig: AllConfig = {
    ...envConfig[env],
    ...otherConfigs[env],
    ...myApprovalConfigs[env],
    ...featureFlagConfig[env],
    ...proxyConfig[env],
};
